import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useEditor, useEditorState } from '../context.js';
import { useT } from '../i18n.js';
/** Modal with focus moved inside and restored on close; Escape cancels. */
export function Modal(props) {
    const box = useRef(null);
    useEffect(() => {
        const prev = document.activeElement;
        box.current?.querySelector('button, input, select, [tabindex]')?.focus();
        return () => prev?.focus?.();
    }, []);
    return (_jsx("div", { className: "dl-dialog-backdrop", children: _jsx("div", { ref: box, className: "dl-dialog", role: "dialog", "aria-modal": "true", "aria-label": props.label, onKeyDown: (e) => {
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    props.onCancel();
                }
            }, children: props.children }) }));
}
export function RecoveryDialog(props) {
    const t = useT();
    return (_jsxs(Modal, { label: t('recovery.title'), onCancel: props.onDiscard, children: [_jsx("h2", { style: { marginTop: 0, fontSize: 16 }, children: t('recovery.title') }), _jsx("p", { children: t('recovery.body', { name: props.meta.name, time: new Date(props.meta.savedAt).toLocaleString() }) }), _jsxs("div", { className: "dl-row", style: { justifyContent: 'flex-end' }, children: [_jsx("button", { type: "button", className: "dl-btn", onClick: props.onDiscard, children: t('recovery.discard') }), _jsx("button", { type: "button", className: "dl-btn dl-primary", onClick: props.onRestore, children: t('recovery.restore') })] })] }));
}
/** Error of the last failed command (from the editor state) or a UI error. */
export function ErrorBanner(props) {
    const { core } = useEditor();
    const t = useT();
    const err = useEditorState((s) => s.error);
    const shown = props.extra ??
        (err
            ? {
                title: t('error.title'),
                message: err.message,
                details: err.diagnostics.flatMap((d) => d.labels),
            }
            : null);
    if (!shown)
        return null;
    return (_jsxs("div", { className: "dl-banner dl-error", role: "alert", style: { margin: 8 }, children: [_jsx("strong", { children: shown.title }), " \u2014 ", shown.message, shown.details && shown.details.length > 0 && (_jsxs("div", { children: [t('error.conflict'), " ", shown.details.join('; ')] })), _jsx("div", { children: _jsx("button", { type: "button", className: "dl-btn", onClick: () => (props.extra ? props.onDismissExtra() : core.clearError()), children: t('error.dismiss') }) })] }));
}
export function MissingPluginsBanner(props) {
    const t = useT();
    if (props.types.length === 0)
        return null;
    return (_jsxs("div", { className: "dl-banner", role: "status", style: { margin: 8 }, children: [_jsx("strong", { children: t('missing.title') }), " \u2014 ", t('missing.body', { types: props.types.join(', ') }), ' ', _jsx("button", { type: "button", className: "dl-btn", onClick: props.onDismiss, children: t('error.dismiss') })] }));
}
//# sourceMappingURL=Dialogs.js.map